<template>
  <div >
    <div style="height: 50px;display: flex;justify-content: flex-start;padding-top: 10px;padding-left: 25px;align-items: center;">
      <img class="back1"  @click="$router.back()"  src="../images/fanhui1.png" mode="heightFix" alt="">
    </div>
    
    <div :style="{height: (screenHeight - 70) + 'px'}" >
      
      <iframe
      :src="iframeSrc"
      style="width: 100%;height: 100%;"
      frameborder="0"
      scrolling="auto"
    ></iframe>
    </div>
  <!-- <van-tabbar route active-color="#000000" >
    <van-tabbar-item replace to="/" icon="home-o">首页</van-tabbar-item>
    <van-tabbar-item replace to="/kefu" icon="service-o">客服</van-tabbar-item>
    <van-tabbar-item replace to="/carts" icon="cart-o">购物车</van-tabbar-item>
    <van-tabbar-item replace to="/personal" icon="contact-o">我的</van-tabbar-item>
  </van-tabbar> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      screenHeight: window.innerHeight,
      iframeSrc:'https://kf.renguokeji.com/kefu/?app=lishun&amp;extra=eyJpZCI6IjljMjA3Yjk1Y2FhOWUzZWE2NmVlYmIxZjNmNDk0ZjE3IiwidXNlcl9pZCI6IjljMjA3Yjk1Y2FhOWUzZWE2NmVlYmIxZjNmNDk0ZjE3IiwiZGV2aWNlX2lkIjoiOWMyMDdiOTVjYWE5ZTNlYTY2ZWViYjFmM2Y0OTRmMTciLCJwbGF0Zm9ybSI6ImFuZHJvaW'
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.screenHeight = window.innerHeight;
    },
  },
};
</script>
<style scoped>
.back1{
    height: 26px;
    /* margin-left: 25px; */
    
    /* margin: 10px 0 10px 25px; */
  }
</style>